/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { useCallback, useEffect } from "react";
import { useLatest } from "./useLatest";

export function useEventCallback<T extends (...args: any[]) => any>(
	fn: T
): (...args: Parameters<T>) => ReturnType<T> {
	const callbackRef = useLatest(fn);

	useEffect(() => {
		return () => {
			callbackRef.current = undefined;
		};
	}, []);

	return useCallback((...args) => {
		return callbackRef.current(...args);
	}, []);
}
